import { GridItemType } from 'components/grid/types';
import { WIDGET_MIN_SIZE_PAGE, WORKSPACE_WIDGET_PAGE_SIZE } from 'const/workspaces/constants';

export const getWorkspaceItem = ({ id, title, to }: { id: string; title: string; to: string }) => ({
  gridItemProps: {
    id,
    type: GridItemType.KINETIC_ROUTE,
    title,
    data: {
      to,
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onGridItemClose: () => {},
    routes: [],
  },
  layout: {
    i: id,
    x: 0,
    y: 0,
    isDraggable: true,
    ...WORKSPACE_WIDGET_PAGE_SIZE,
    ...WIDGET_MIN_SIZE_PAGE,
  },
});
